import { Capacitor } from "@capacitor/core";

/**
 * Hides the splash screen.
 * On native platforms, dismisses the native splash screen.
 * On web, this is a no-op.
 */
export async function hideSplashScreen(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const { SplashScreen } = await import("@capacitor/splash-screen");
  await SplashScreen.hide();
}
